/**
 * Auto add uiid to items
 * @param {String} dataUiid
 * @param {Array} items
 * @returns
 */
export const setItemDataUiids = (dataUiid, items) => {
  const itemsWithDataUiid = items.map((i) => {
    return {
      ...i,
      dataUiid: `${dataUiid}_${i.value}`,
    };
  });
  return itemsWithDataUiid;
};

export const setItemTextDevice = (items, isMobile) => {
  if (!isMobile) {
    return;
  }
  items.forEach((item) => {
    if (item.mobileText) {
      item.text = item.mobileText;
    }
  });
};

export const COVER_TYPE_ITEMS = [
  {
    text: "Buildings &amp;<br>Contents",
    value: "BuildingsAndContents",
    image: {
      class: "building-contents",
      path: "ic_buildings_and_contents.svg",
      width: "116px",
      alt: "Buildings And Contents",
    },
  },
  {
    text: "Buildings<br>Only",
    value: "BuildingsOnly",
    image: {
      class: "building-only",
      path: "ic_buildings.svg",
      width: "82px",
      alt: "Buildings Only",
    },
  },
];
export const HOME_COVER_TYPE_ITEMS = [
  {
    text: "Buildings &amp;<br>Contents",
    value: "BuildingsAndContents",
    image: {
      class: "building-contents",
      path: "ic_buildings_and_contents.svg",
      width: "116px",
      height: "80px",
      alt: "Buildings And Contents",
    },
  },
  {
    text: "Buildings<br>only",
    value: "BuildingsOnly",
    image: {
      class: "building-only",
      path: "ic_buildings.svg",
      width: "82px",
      height: "80px",
      alt: "Buildings only",
    },
  },
  {
    text: "Contents<br>only",
    value: "ContentsOnly",
    image: {
      class: "contents-only",
      path: "ic_contents.svg",
      width: "82px",
      height: "80px",
      alt: "Contents only",
    },
  },
];

export const COVER_TYPE_ITEMS_LANDLORDS_SMALL = [
  {
    text: "Buildings &amp;<br>Contents",
    value: "BuildingsAndContents",
    image: {
      path: "ic_buildings_and_contents.svg",
      width: "72px",
      alt: "Buildings And Contents",
    },
  },
  {
    text: "Buildings<br>Only",
    value: "BuildingsOnly",
    image: {
      path: "ic_buildings.svg",
      width: "50px",
      alt: "Buildings Only",
    },
  },
];

export const COVER_TYPE_ITEMS_HOME = [
  {
    text: "Buildings &amp;<br>contents",
    value: "BuildingsAndContents",
    image: {
      path: "ic_buildings_and_contents.svg",
      width: "116px",
      alt: "Buildings and contents",
    },
    font: "12px",
  },
  {
    text: "Buildings<br>only",
    value: "BuildingsOnly",
    image: {
      path: "ic_buildings.svg",
      width: "82px",
      alt: "Buildings only",
    },
    font: "12px",
  },
  {
    text: "Contents<br>only",
    value: "ContentsOnly",
    image: {
      path: "ic_contents.svg",
      width: "74px",
      alt: "Contents only",
    },
    font: "12px",
  },
];

export const COVER_TYPE_ITEMS_HOME_SMALL = [
  {
    text: "Buildings &amp;<br>contents",
    value: "BuildingsAndContents",
    image: {
      path: "ic_buildings_and_contents.svg",
      width: "72px",
      alt: "Buildings and contents",
    },
  },
  {
    text: "Buildings<br>only",
    value: "BuildingsOnly",
    image: {
      path: "ic_buildings.svg",
      width: "50px",
      alt: "Buildings only",
    },
  },
  {
    text: "Contents<br>only",
    value: "ContentsOnly",
    image: {
      path: "ic_contents.svg",
      width: "47px",
      alt: "Contents only",
    },
  },
];

export const APPLICANT_TITLE_ITEMS = [
  {
    text: "Mr",
    value: "Mr",
  },
  {
    text: "Mrs",
    value: "Mrs",
  },
  {
    text: "Miss",
    value: "Miss",
  },
  {
    text: "Ms",
    value: "Ms",
  },
  {
    text: "Dr",
    value: "Dr",
  },
  {
    text: "Rev",
    value: "Rev",
  },
];

export const APPLICANT_TITLE_ITEMS_PLUS_MX = [
  {
    text: "Mr",
    value: "Mr",
  },
  {
    text: "Mrs",
    value: "Mrs",
  },
  {
    text: "Miss",
    value: "Miss",
  },
  {
    text: "Ms",
    value: "Ms",
  },
  {
    text: "Mx",
    value: "Mx",
  },
  {
    text: "Dr",
    value: "Dr",
  },
  {
    text: "Rev",
    value: "Rev",
  },
];

export const NO_OF_RENTAL_PROPERTIES_ITEMS = [
  {
    text: "1",
    value: "One",
  },
  {
    text: "2",
    value: "Two",
  },
  {
    text: "3",
    value: "Three",
  },
  {
    text: "4",
    value: "Four",
  },
  {
    text: "5",
    value: "Five",
  },
  {
    text: "6",
    value: "Six",
  },
  {
    text: "7",
    value: "Seven",
  },
  {
    text: "8",
    value: "Eight",
  },
  {
    text: "9",
    value: "Nine",
  },
  {
    text: "10",
    value: "Ten",
  },
  {
    text: "11+",
    value: "TenPlus",
  },
];

export const PREVIOUS_CLAIM_CLAIMED_UNDER_ITEMS = [
  {
    text: "Buildings",
    value: "BuildingsOnly",
  },
  {
    text: "Contents",
    value: "ContentsOnly",
  },
  {
    text: "Combined",
    value: "BuildingsAndContents",
  },
];

export const PREVIOUS_CLAIM_TYPE_OF_LOSS_ITEMS = [
  {
    text: "Accidental Damage",
    value: "AccidentalDamage",
  },
  {
    text: "Accidental Loss",
    value: "AccidentalLoss",
  },
  {
    text: "Burst Pipes",
    value: "BurstPipes",
  },
  {
    text: "Drains and Underground Tanks",
    value: "DrainsAndUndergroundTanks",
  },
  {
    text: "Earthquake",
    value: "Earthquake",
  },
  {
    text: "Escape Of Oil",
    value: "EscapeOfOil",
  },
  {
    text: "Escape Of Water",
    value: "EscapeOfWater",
  },
  {
    text: "Explosion",
    value: "Explosion",
  },
  {
    text: "Fire",
    value: "Fire",
  },
  {
    text: "Flood",
    value: "Flood",
  },
  {
    text: "Freezer Contents",
    value: "FreezerContents",
  },
  {
    text: "Glass / Mirrors",
    value: "GlassMirrors",
  },
  {
    text: "Impact",
    value: "Impact",
  },
  {
    text: "Liability",
    value: "Liability",
  },
  {
    text: "Lightning",
    value: "Lightning",
  },
  {
    text: "Malicious Damage / Riot",
    value: "MaliciousDamageRiot",
  },
  {
    text: "Storm Damage",
    value: "StormDamage",
  },
  {
    text: "Subsidence",
    value: "Subsidence",
  },
  {
    text: "Theft",
    value: "Theft",
  },
  {
    text: "Underground Service Pipe",
    value: "UndergroundServicePipe",
  },
];

export const LANDLORDS_PREVIOUS_CLAIM_TYPE_OF_LOSS_ITEMS = [
  {
    text: "Accidental Damage",
    value: "AccidentalDamage",
  },
  {
    text: "Accidental Loss",
    value: "AccidentalLoss",
  },
  {
    text: "Burst Pipes",
    value: "BurstPipes",
  },
  {
    text: "Drains and Underground Tanks",
    value: "DrainsAndUndergroundTanks",
  },
  {
    text: "Earthquake",
    value: "Earthquake",
  },
  {
    text: "Escape Of Oil",
    value: "EscapeOfOil",
  },
  {
    text: "Escape Of Water",
    value: "EscapeOfWater",
  },
  {
    text: "Explosion",
    value: "Explosion",
  },
  {
    text: "Fire",
    value: "Fire",
  },
  {
    text: "Flood",
    value: "Flood",
  },
  {
    text: "Glass / Mirrors",
    value: "GlassMirrors",
  },
  {
    text: "Impact",
    value: "Impact",
  },
  {
    text: "Liability",
    value: "Liability",
  },
  {
    text: "Lightning",
    value: "Lightning",
  },
  {
    text: "Malicious Damage / Riot",
    value: "MaliciousDamageRiot",
  },
  {
    text: "Storm Damage",
    value: "StormDamage",
  },
  {
    text: "Subsidence",
    value: "Subsidence",
  },
  {
    text: "Theft",
    value: "Theft",
  },
  {
    text: "Underground Service Pipe",
    value: "UndergroundServicePipe",
  },
];

export const TENANTS_CONTENT_PREVIOUS_CLAIM_TYPE_OF_LOSS_ITEMS = [
  {
    text: "Accidental Damage",
    value: "AccidentalDamage",
  },
  {
    text: "Accidental Loss",
    value: "AccidentalLoss",
  },
  {
    text: "Earthquake",
    value: "Earthquake",
  },
  {
    text: "Escape Of Oil",
    value: "EscapeOfOil",
  },
  {
    text: "Escape Of Water",
    value: "EscapeOfWater",
  },
  {
    text: "Explosion",
    value: "Explosion",
  },
  {
    text: "Fire",
    value: "Fire",
  },
  {
    text: "Flood",
    value: "Flood",
  },
  {
    text: "Freezer Contents",
    value: "FreezerContents",
  },
  {
    text: "Glass / Mirrors",
    value: "GlassMirrors",
  },
  {
    text: "Impact",
    value: "Impact",
  },
  {
    text: "Liability",
    value: "Liability",
  },
  {
    text: "Lightning",
    value: "Lightning",
  },
  {
    text: "Malicious Damage / Riot",
    value: "MaliciousDamageRiot",
  },
  {
    text: "Storm Damage",
    value: "StormDamage",
  },
  {
    text: "Subsidence",
    value: "Subsidence",
  },
  {
    text: "Theft",
    value: "Theft",
  },
];

export const NO_CLAIMS_BUILDINGS_ITEMS = [
  {
    text: "0",
    value: "Zero",
  },
  {
    text: "1",
    value: "One",
  },
  {
    text: "2",
    value: "Two",
  },
  {
    text: "3",
    value: "Three",
  },
  {
    text: "4",
    value: "Four",
  },
  {
    text: "5",
    value: "Five",
  },
  {
    text: "6",
    value: "Six",
  },
  {
    text: "7",
    value: "Seven",
  },
  {
    text: "8",
    value: "Eight",
  },
  {
    text: "9+",
    value: "NinePlus",
  },
];

export const NO_CLAIMS_CONTENTS_ITEMS = [
  {
    text: "0",
    value: "Zero",
  },
  {
    text: "1",
    value: "One",
  },
  {
    text: "2",
    value: "Two",
  },
  {
    text: "3",
    value: "Three",
  },
  {
    text: "4",
    value: "Four",
  },
  {
    text: "5",
    value: "Five",
  },
  {
    text: "6",
    value: "Six",
  },
  {
    text: "7",
    value: "Seven",
  },
  {
    text: "8",
    value: "Eight",
  },
  {
    text: "9+",
    value: "NinePlus",
  },
];

export const ALARM_TYPE_ITEMS = [
  {
    text: "No Alarm",
    value: "NoAlarm",
  },
  {
    text: "Non-Maintained Alarm",
    value: "NonMaintained",
  },
  {
    text: "Annually Maintained Alarm",
    value: "AnnuallyMaintained",
  },
];

export const PROPERTIES_TYPE_ITEMS = [
  {
    text: "Detached<br>house",
    image: {
      path: "ic_property_detached.svg",
      maxWidth: "55px",
      imageName: "Detached House",
      maxHeight: "auto",
    },
    value: "DetachedHouse",
  },
  {
    text: "Semi-detached<br>house",
    image: {
      path: "ic_property_semidetached.svg",
      maxWidth: "92px",
      imageName: "Semi Detached House",
      maxHeight: "auto",
    },
    value: "SemiDetachedHouse",
  },
  {
    text: "Terraced<br>house",
    image: {
      path: "ic_property_terraced.svg",
      maxWidth: "130px",
      imageName: "Terraced",
      maxHeight: "auto",
    },
    value: "Terraced",
  },
  {
    text: "Dormer<br>bungalow",
    image: {
      path: "ic_property_dormer.svg",
      maxWidth: "55px",
      imageName: "Dormer Bungalow",
      maxHeight: "auto",
    },
    value: "DormerBungalow",
  },
  {
    text: "Flat",
    image: {
      path: "ic_property_flat.svg",
      maxWidth: "42px",
      imageName: "Flat",
      maxHeight: "auto",
    },
    value: "Flat",
  },
  {
    text: "Detached<br>bungalow",
    image: {
      path: "ic_property_detachedbungalow.svg",
      maxWidth: "55px",
      imageName: "Detached Bungalow",
      maxHeight: "auto",
    },
    value: "DetachedBungalow",
  },
  {
    text: "Semi-detached<br>bungalow",
    image: {
      path: "ic_property_semidetachedbungalow.svg",
      maxWidth: "92px",
      imageName: "Semi Detached Bungalow",
      maxHeight: "auto",
    },
    value: "SemiDetachedBungalow",
  },
];

export const TENANTS_CONTENT_PROPERTIES_TYPE_ITEMS = [
  {
    text: "Detached<br>house",
    image: {
      path: "ic_property_detached.svg",
      maxWidth: "55px",
      imageName: "Detached House",
      maxHeight: "auto",
    },
    value: "DetachedHouse",
  },
  {
    text: "Semi-detached<br>house",
    image: {
      path: "ic_property_semidetached.svg",
      maxWidth: "92px",
      imageName: "Semi Detached House",
      maxHeight: "auto",
    },
    value: "SemiDetachedHouse",
  },
  {
    text: "Terraced<br>house",
    image: {
      path: "ic_property_terraced.svg",
      maxWidth: "130px",
      imageName: "Terraced",
      maxHeight: "auto",
    },
    value: "Terraced",
  },
  {
    text: "Flat - Ground<br>floor or below",
    image: {
      path: "ic_flat_lower.svg",
      maxWidth: "90px",
      imageName: "Flat - Ground floor or below",
      maxHeight: "auto",
    },
    value: "GroundFloorFlat",
  },
  {
    text: "Flat - First<br>floor or above",
    image: {
      path: "ic_flat_upper.svg",
      maxWidth: "90px",
      imageName: "Flat - First floor or above",
      maxHeight: "auto",
    },
    value: "AboveGroundFloorFlat",
  },
  {
    text: "Detached<br>bungalow",
    image: {
      path: "ic_property_detachedbungalow.svg",
      maxWidth: "55px",
      imageName: "Detached Bungalow",
      maxHeight: "auto",
    },
    value: "DetachedBungalow",
  },
  {
    text: "Semi-detached<br>bungalow",
    image: {
      path: "ic_property_semidetachedbungalow.svg",
      maxWidth: "92px",
      imageName: "Semi Detached Bungalow",
      maxHeight: "auto",
    },
    value: "SemiDetachedBungalow",
  },
  {
    text: "Dormer<br>bungalow",
    image: {
      path: "ic_property_dormer.svg",
      maxWidth: "55px",
      imageName: "Dormer Bungalow",
      maxHeight: "auto",
    },
    value: "DormerBungalow",
  },
];

export const ROOF_CONSTRUCTION_ITEMS = [
  {
    text: "Tile",
    value: "Tile",
  },
  {
    text: "Slate",
    value: "Slate",
  },
  {
    text: "Felt on timber",
    value: "FeltOnTimber",
  },
  {
    text: "Concrete",
    value: "Concrete",
  },
  {
    text: "Metal",
    value: "Metal",
  },
  {
    text: "Timber",
    value: "Timber",
  },
  {
    text: "Asphalt",
    value: "Asphalt",
  },
  {
    text: "Shingle",
    value: "Shingle",
  },
  {
    text: "Stramit",
    value: "Stramit",
  },
  {
    text: "Thatch fibre",
    value: "ThatchFibre",
  },
  {
    text: "Thatch reed",
    value: "ThatchReed",
  },
  {
    text: "Other",
    value: "Other",
  },
];

export const WALL_CONSTRUCTION_ITEMS = [
  {
    text: "Brick",
    value: "Brick",
  },
  {
    text: "Concrete",
    value: "Concrete",
  },
  {
    text: "Stone",
    value: "Stone",
  },
  {
    text: "Flint",
    value: "Flint",
  },
  {
    text: "Timber",
    value: "Timber",
  },
  {
    text: "Metal",
    value: "Metal",
  },
  {
    text: "Other",
    value: "Other",
  },
];

export const HOME_ROOF_CONSTRUCTION_ITEMS = [
  {
    text: "Tile",
    value: "Tile",
  },
  {
    text: "Slate",
    value: "Slate",
  },
  {
    text: "Felt on timber",
    value: "FeltOnTimber",
  },
  {
    text: "Concrete",
    value: "Concrete",
  },
  {
    text: "Metal",
    value: "Metal",
  },
  {
    text: "Timber",
    value: "Timber",
  },
  {
    text: "Asphalt",
    value: "Asphalt",
  },
  {
    text: "Shingle",
    value: "Shingle",
  },
  {
    text: "Stramit",
    value: "Stramit",
  },
  {
    text: "Thatch fibre",
    value: "ThatchFibre",
  },
  {
    text: "Thatch reed",
    value: "ThatchReed",
  },
  {
    text: "Ethylene Propylene Diene Monomer EPDM",
    value: "EPDM",
  },
  {
    text: "Fibreglass",
    value: "Fibreglass",
  },
  {
    text: "Other",
    value: "Other",
  },
];
export const HOME_WALL_CONSTRUCTION_ITEMS = [
  {
    text: "Brick",
    value: "Brick",
  },
  {
    text: "Concrete",
    value: "Concrete",
  },
  {
    text: "Stone",
    value: "Stone",
  },
  {
    text: "Flint",
    value: "Flint",
  },
  {
    text: "Timber",
    value: "Timber",
  },
  {
    text: "Metal",
    value: "Metal",
  },
  {
    text: "Prefabricated Building - Combustible Materials",
    value: "PrefabricatedBuildingCombustibleMaterials",
  },
  {
    text: "Prefabricated Building - Non-Combustible Materials",
    value: "PrefabricatedBuildingNonCombustibleMaterials",
  },
  {
    text: "Timber Frame/Stone",
    value: "TimberFrameStone",
  },
  {
    text: "Other",
    value: "Other",
  },
];

export const ANSWER_CONTROL_COUNTER_OPTIONS = {
  Count: 1,
  CountValues: {
    1: {
      Value: "One",
      DisplayValue: "1",
    },
    2: {
      Value: "Two",
      DisplayValue: "2",
    },
    3: {
      Value: "Three",
      DisplayValue: "3",
    },
    4: {
      Value: "Four",
      DisplayValue: "4",
    },
    5: {
      Value: "Five",
      DisplayValue: "5",
    },
    6: {
      Value: "Six",
      DisplayValue: "6",
    },
    7: {
      Value: "Seven",
      DisplayValue: "7",
    },
    8: {
      Value: "Eight",
      DisplayValue: "8",
    },
  },
  CountMaxValue: 8,
  CountMinValue: 1,
};

export const ANSWER_CONTROL_BED_ROOM_COUNTER_OPTIONS = {
  Count: 1,
  CountValues: {
    1: {
      Value: "One",
      DisplayValue: "1",
    },
    2: {
      Value: "Two",
      DisplayValue: "2",
    },
    3: {
      Value: "Three",
      DisplayValue: "3",
    },
    4: {
      Value: "Four",
      DisplayValue: "4",
    },
    5: {
      Value: "Five",
      DisplayValue: "5",
    },
    6: {
      Value: "Six",
      DisplayValue: "6",
    },
    7: {
      Value: "Seven",
      DisplayValue: "7",
    },
    8: {
      Value: "Eight",
      DisplayValue: "8",
    },
  },
  CountMaxValue: 8,
  CountMinValue: 1,
};

export const BASIS_OF_ADVICE = [
  {
    text: "Advised",
    value: "Advised",
  },
  {
    text: "Non Advised",
    value: "NonAdvised",
  },
];

export const BASIS_OF_ADVICE_FOR_ADVISED = [
  {
    text: "Advised",
    value: "Advised",
  },
];

export const TERM_OF_INSURANCE_OPTIONS = [
  {
    text: "6 months",
    value: "SixMonths",
  },
  {
    text: "12 months",
    value: "TwelveMonths",
  },
];

export const DOCUMENT_DELIVERY_PREFERENCE_OPTIONS = [
  {
    text: "Online",
    value: "Online",
  },
  {
    text: "Post",
    value: "Postal",
  },
];

export const TYPE_OF_BORROWING = [
  {
    text: "New Borrower (house purchase)",
    value: "New",
  },
  {
    text: "Re-mortgage",
    value: "ReMortgage",
  },
];

export const EMPLOYMENT_STATUS = [
  {
    text: "Employed",
    value: "Employed",
  },
  {
    text: "Self Employed",
    value: "SelfEmployed",
  },
  {
    text: "Shareholding Director",
    value: "ShareholdingDirector",
  },
  {
    text: "Proprietor",
    value: "Proprietor",
  },
  {
    text: "Fixed Term Contract Worker",
    value: "FixedTermContractWorker",
  },
];

export const JOB_ROLE = [
  { value: "Accountant", text: "Accountant" },
  { value: "Administrative", text: "Administrative" },
  { value: "Agriculture", text: "Agriculture Farming" },
  { value: "Catering", text: "Catering" },
  { value: "Director", text: "Company Director" },
  { value: "Distribution", text: "Distribution" },
  { value: "Emergency", text: "Emergency Services" },
  { value: "Engineering", text: "Engineering" },
  { value: "Financial", text: "Financial Services" },
  { value: "Government", text: "Local Government" },
  { value: "Management", text: "Management" },
  { value: "Manual", text: "Manual Work" },
  { value: "Manufacturing", text: "Manufacturing" },
  { value: "Medical", text: "Medical Professional" },
  { value: "MedicalNonQualified", text: "Medical Non qualified" },
  { value: "Mining", text: "Mining" },
  { value: "NotKnown", text: "Not Known" },
  { value: "Professional", text: "Professional Industries" },
  { value: "Retail", text: "Retail" },
  { value: "Secretarial", text: "Secretarial" },
  { value: "SelfEmployed", text: "Self-Employed" },
  { value: "SocialServices", text: "Social Services" },
  { value: "Solicitors", text: "Solicitors" },
  { value: "Telecommunications", text: "Telecommunications" },
];

export const RP_DOCUMENT_DELIVERY_PREFERENCE_OPTIONS = [
  {
    text: "Online",
    value: "Email",
  },
  {
    text: "Post",
    value: "Postal",
  },
];
